import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddFloorTypeModal from "./components/AddFloorTypeModal";
import FloorTypeTable from "./components/FloorTypeTable";
import { selectList, selectLoading, selectMeta } from "./redux/selector";
import floorTypeSaga from "./redux/saga";
import { actions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const FloorType = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: floorTypeSaga,
  });

  const rows = useSelector(selectList);
  const loading = useSelector(selectLoading);
  const meta = useSelector(selectMeta);

  useEffect(() => {
    dispatch(actions.getList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(actions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.FLOOR_TYPE")} iconPosition="end" />
          <Box dir="ltr">
            <AddButton
              label={t("FLOOR_TYPE.ACTIONS.ADD")}
              onClick={() => dispatch(actions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <FloorTypeTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddFloorTypeModal />
    </Box>
  );
};

export default FloorType;
